// CORS-open, CC-licensed tracks; credit is written into the output mp4's metadata.
const BACKGROUND_MUSIC_TRACKS = {
  'PolicyMogul background music': {
    url: 'https://archive.org/download/sneaky-snitch-by-kevin-macleod/sneaky-snitch-by-kevin-macleod.mp3',
    credit: 'Music: "Sneaky Snitch" by Kevin MacLeod (incompetech.com) — CC BY-ND 4.0',
  },
  'Legis-late night jazz': {
    url: 'https://archive.org/download/local-forecast-by-kevin-macleod/local-forecast-by-kevin-macleod.mp3',
    credit: 'Music: "Local Forecast" by Kevin MacLeod (incompetech.com) — CC BY 4.0',
  },
  'Govern-metal': {
    url: 'https://archive.org/download/BigRock_201803/Big%20Rock.mp3',
    credit: 'Music: "Big Rock" by Kevin MacLeod (incompetech.com) — CC BY-ND 3.0',
  },
};

export { BACKGROUND_MUSIC_TRACKS };
